import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { SettingsProvider } from './contexts/SettingsContext';
import CodeEditor from './components/CodeEditor';
import StartScreen from './components/StartScreen';
import InstallPrompt from './components/InstallPrompt';
import UpdatePrompt from './components/UpdatePrompt';
import OfflineIndicator from './components/OfflineIndicator';
import { useMobile } from './hooks/useMobile';

// Mobile-optimized CodeEditor
import MobileCodeEditor from './components/MobileCodeEditor';

function AppContent() {
  const { isMobile } = useMobile();

  useEffect(() => {
    // Register service worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('✅ SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('❌ SW registration failed: ', registrationError);
          });
      });
    }

    // Handle PWA shortcuts
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get('action');
    
    if (action) {
      // Handle app shortcuts
      setTimeout(() => {
        if (action === 'new') {
          // Trigger new project modal
          const event = new CustomEvent('pwa-shortcut', { detail: { action: 'new' } });
          window.dispatchEvent(event);
        } else if (action === 'ai') {
          // Trigger AI creator
          const event = new CustomEvent('pwa-shortcut', { detail: { action: 'ai' } });
          window.dispatchEvent(event);
        }
      }, 1000);
    }
  }, []);

  return (
    <Router>
      <div className="h-screen bg-gray-900 text-white">
        <Routes>
          <Route path="/" element={<StartScreen />} />
          <Route 
            path="/editor" 
            element={
              isMobile ? <MobileCodeEditor /> : <CodeEditor />
            } 
          />
        </Routes>
        
        {/* PWA Components */}
        <InstallPrompt />
        <UpdatePrompt />
        <OfflineIndicator />
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <ProjectProvider>
          <AppContent />
        </ProjectProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;